import React, { useState } from "react";
import "../assetss/styles/header.css";
import copy from 'clipboard-copy';
import { useLocation, Link, useNavigate } from "react-router-dom";
import {
  TelegramShareButton,
  WhatsappShareButton,
  EmailShareButton,
  TelegramIcon,
  WhatsappIcon,
  EmailIcon,
} from "react-share";
import leoLogo from '../assetss/img/leoLogo.png'
const Header = ({ setSearchQuery, searchQuery, cartItems }) => {
  const shareURL = window.location.href;
  const shareText = "برای مسیر یابی بر روی لینک کلیک کنید.";
  let location = useLocation();
  const navigate = useNavigate();
  const goBack = () => {
    // Navigate back to the previous page
    navigate(-1);
  };
  const counterItem = cartItems.length;
  // const [text , setText] = useState('')
  const [show, setShow] = useState(false);
  const [showCopy, setShowCopy] = useState(false);
  const [copied, setCopied] = useState(false);
  const copy =  () => {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setCopied(true);
    setShowCopy(true)
    setTimeout(() => {
      setShowCopy(false)
    }, 1000);

  }
  return (
    <header className="header sticky top-0 z-20 shadow dark:shadow-slate-500 h-20 flex justify-between items-center px-4 bg-white dark:bg-gray-700 ">
      {location.pathname == "/" && (
        <>
          {/* <h2 className="dark:text-white">کافه لئو</h2> */}
          <img className="w-16" src={leoLogo} alt="" />
          <div className="div flex relative">
            {/* <span className="badge">0</span> */}
            <Link to="/shopCart">
              <span className="h-10 w-10 shadow-md dark:bg-gray-800 shadow-gray-600 dark:shadow-slate-400 rounded flex justify-center items-center relative  ">
                {counterItem > 0 && (
                  <p className="badge text-white  w-6 h-6 bg-red-600 rounded-full absolute -top-3 -right-3 text-center">
                    {counterItem}
                  </p>
                )}

                <svg
                  className="dark:invert"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M19.24 5.58006H18.84L15.46 2.20006C15.19 1.93006 14.75 1.93006 14.47 2.20006C14.2 2.47006 14.2 2.91006 14.47 3.19006L16.86 5.58006H7.14L9.53 3.19006C9.8 2.92006 9.8 2.48006 9.53 2.20006C9.26 1.93006 8.82 1.93006 8.54 2.20006L5.17 5.58006H4.77C3.87 5.58006 2 5.58006 2 8.14006C2 9.11006 2.2 9.75006 2.62 10.1701C2.86 10.4201 3.15 10.5501 3.46 10.6201C3.75 10.6901 4.06 10.7001 4.36 10.7001H19.64C19.95 10.7001 20.24 10.6801 20.52 10.6201C21.36 10.4201 22 9.82006 22 8.14006C22 5.58006 20.13 5.58006 19.24 5.58006Z"
                    fill="#292D32"
                  />
                  <path
                    d="M19.6509 10.7001H4.36094C4.07094 10.7001 3.75094 10.6901 3.46094 10.6101L4.72094 18.3001C5.00094 20.0201 5.75094 22.0001 9.08094 22.0001H14.6909C18.0609 22.0001 18.6609 20.3101 19.0209 18.4201L20.5309 10.6101C20.2509 10.6801 19.9509 10.7001 19.6509 10.7001ZM12.0009 18.5001C9.66094 18.5001 7.75094 16.5901 7.75094 14.2501C7.75094 13.8401 8.09094 13.5001 8.50094 13.5001C8.91094 13.5001 9.25094 13.8401 9.25094 14.2501C9.25094 15.7701 10.4809 17.0001 12.0009 17.0001C13.5209 17.0001 14.7509 15.7701 14.7509 14.2501C14.7509 13.8401 15.0909 13.5001 15.5009 13.5001C15.9109 13.5001 16.2509 13.8401 16.2509 14.2501C16.2509 16.5901 14.3409 18.5001 12.0009 18.5001Z"
                    fill="#292D32"
                  />
                </svg>
              </span>
            </Link>
          </div>
        </>
      )}
      {location.pathname == "/chooseFood" && (
        <>
          <Link to="/">
            <span className="h-10 w-10 shadow-md dark:bg-gray-800 shadow-gray-600 dark:shadow-slate-400 rounded flex justify-center items-center relative ">
              <svg
                className="dark:invert"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M20.03 6.82018L14.28 2.79018C12.71 1.69018 10.31 1.75018 8.8 2.92018L3.79 6.83018C2.78 7.61018 2 9.21018 2 10.4702V17.3702C2 19.9202 4.07 22.0002 6.61 22.0002H17.38C19.92 22.0002 21.99 19.9302 21.99 17.3802V10.6002C22 9.25018 21.13 7.59018 20.03 6.82018Z"
                  fill="#292D32"
                />
                <path
                  d="M13.3994 8.51025H10.5994C8.67938 8.51025 7.10938 10.0703 7.10938 12.0003V14.7903C7.10938 16.7103 8.67938 18.2803 10.5994 18.2803H13.3894C15.3094 18.2803 16.8794 16.7203 16.8794 14.7903V12.0003C16.8794 10.0803 15.3194 8.51025 13.3994 8.51025ZM15.4894 12.0003V12.7003H12.6994V9.91025H13.3994C14.5494 9.91025 15.4894 10.8503 15.4894 12.0003ZM10.5994 9.91025H11.2994V12.7003H8.50938V12.0003C8.50938 10.8503 9.44938 9.91025 10.5994 9.91025ZM8.50938 14.7903V14.0903H11.2994V16.8803H10.5994C9.44938 16.8803 8.50938 15.9403 8.50938 14.7903ZM13.3994 16.8803H12.6994V14.0903H15.4894V14.7903C15.4894 15.9403 14.5494 16.8803 13.3994 16.8803Z"
                  fill="#292D32"
                />
              </svg>
            </span>
          </Link>
          <input
            type="text"
            className="appearance-none outline-none p-2 w-3/5 rounded bg-grayz-100 focus:bg-gray-200 
             dark:bg-gray-800 bg-gray-100
             dark:focus:bg-gray-900 dark:placeholder:text-white dark:text-white "
            placeholder="جستجو غذا"
            onChange={(e) => setSearchQuery(e.target.value)}
            value={searchQuery}
          />
          <div className="div flex ">
            {/* <span className="badge">0</span> */}
            <Link to="/shopCart">
              <span className="h-10 w-10 shadow-md dark:bg-gray-800 shadow-gray-600 dark:shadow-slate-400 rounded flex justify-center items-center relative  ">
                {counterItem > 0 && (
                  <p className="badge text-white  w-6 h-6 bg-red-600 rounded-full absolute -top-3 -right-3 text-center">
                    {counterItem}
                  </p>
                )}

                <svg
                  className="dark:invert"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M19.24 5.58006H18.84L15.46 2.20006C15.19 1.93006 14.75 1.93006 14.47 2.20006C14.2 2.47006 14.2 2.91006 14.47 3.19006L16.86 5.58006H7.14L9.53 3.19006C9.8 2.92006 9.8 2.48006 9.53 2.20006C9.26 1.93006 8.82 1.93006 8.54 2.20006L5.17 5.58006H4.77C3.87 5.58006 2 5.58006 2 8.14006C2 9.11006 2.2 9.75006 2.62 10.1701C2.86 10.4201 3.15 10.5501 3.46 10.6201C3.75 10.6901 4.06 10.7001 4.36 10.7001H19.64C19.95 10.7001 20.24 10.6801 20.52 10.6201C21.36 10.4201 22 9.82006 22 8.14006C22 5.58006 20.13 5.58006 19.24 5.58006Z"
                    fill="#292D32"
                  />
                  <path
                    d="M19.6509 10.7001H4.36094C4.07094 10.7001 3.75094 10.6901 3.46094 10.6101L4.72094 18.3001C5.00094 20.0201 5.75094 22.0001 9.08094 22.0001H14.6909C18.0609 22.0001 18.6609 20.3101 19.0209 18.4201L20.5309 10.6101C20.2509 10.6801 19.9509 10.7001 19.6509 10.7001ZM12.0009 18.5001C9.66094 18.5001 7.75094 16.5901 7.75094 14.2501C7.75094 13.8401 8.09094 13.5001 8.50094 13.5001C8.91094 13.5001 9.25094 13.8401 9.25094 14.2501C9.25094 15.7701 10.4809 17.0001 12.0009 17.0001C13.5209 17.0001 14.7509 15.7701 14.7509 14.2501C14.7509 13.8401 15.0909 13.5001 15.5009 13.5001C15.9109 13.5001 16.2509 13.8401 16.2509 14.2501C16.2509 16.5901 14.3409 18.5001 12.0009 18.5001Z"
                    fill="#292D32"
                  />
                </svg>
              </span>
            </Link>
          </div>
        </>
      )}
      {location.pathname == location.state && (
        <>
          <Link to="/">
            <span className="h-10 w-10 shadow-md dark:bg-gray-800 shadow-gray-600 dark:shadow-slate-400 rounded flex justify-center items-center relative ">
              <svg
                className="dark:invert"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M20.03 6.82018L14.28 2.79018C12.71 1.69018 10.31 1.75018 8.8 2.92018L3.79 6.83018C2.78 7.61018 2 9.21018 2 10.4702V17.3702C2 19.9202 4.07 22.0002 6.61 22.0002H17.38C19.92 22.0002 21.99 19.9302 21.99 17.3802V10.6002C22 9.25018 21.13 7.59018 20.03 6.82018Z"
                  fill="#292D32"
                />
                <path
                  d="M13.3994 8.51025H10.5994C8.67938 8.51025 7.10938 10.0703 7.10938 12.0003V14.7903C7.10938 16.7103 8.67938 18.2803 10.5994 18.2803H13.3894C15.3094 18.2803 16.8794 16.7203 16.8794 14.7903V12.0003C16.8794 10.0803 15.3194 8.51025 13.3994 8.51025ZM15.4894 12.0003V12.7003H12.6994V9.91025H13.3994C14.5494 9.91025 15.4894 10.8503 15.4894 12.0003ZM10.5994 9.91025H11.2994V12.7003H8.50938V12.0003C8.50938 10.8503 9.44938 9.91025 10.5994 9.91025ZM8.50938 14.7903V14.0903H11.2994V16.8803H10.5994C9.44938 16.8803 8.50938 15.9403 8.50938 14.7903ZM13.3994 16.8803H12.6994V14.0903H15.4894V14.7903C15.4894 15.9403 14.5494 16.8803 13.3994 16.8803Z"
                  fill="#292D32"
                />
              </svg>
            </span>
          </Link>
          <input
            type="text"
            className="appearance-none outline-none p-2 w-3/5 rounded bg-gray-100 focus:bg-gray-200 
           dark:bg-gray-800 
           dark:focus:bg-gray-900 dark:placeholder:text-white dark:text-white "
            placeholder="جستجو غذا"
            onChange={(e) => setSearchQuery(e.target.value)}
            value={searchQuery}
          />
          <div className="div flex ">
            {/* <span className="badge">0</span> */}
            <Link to="/shopCart">
              <span className="h-10 w-10 shadow-md dark:bg-gray-800 shadow-gray-600 dark:shadow-slate-400 rounded flex justify-center items-center relative  ">
                {counterItem > 0 && (
                  <p className="badge text-white  w-6 h-6 bg-red-600 rounded-full absolute -top-3 -right-3 text-center">
                    {counterItem}
                  </p>
                )}

                <svg
                  className="dark:invert"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M19.24 5.58006H18.84L15.46 2.20006C15.19 1.93006 14.75 1.93006 14.47 2.20006C14.2 2.47006 14.2 2.91006 14.47 3.19006L16.86 5.58006H7.14L9.53 3.19006C9.8 2.92006 9.8 2.48006 9.53 2.20006C9.26 1.93006 8.82 1.93006 8.54 2.20006L5.17 5.58006H4.77C3.87 5.58006 2 5.58006 2 8.14006C2 9.11006 2.2 9.75006 2.62 10.1701C2.86 10.4201 3.15 10.5501 3.46 10.6201C3.75 10.6901 4.06 10.7001 4.36 10.7001H19.64C19.95 10.7001 20.24 10.6801 20.52 10.6201C21.36 10.4201 22 9.82006 22 8.14006C22 5.58006 20.13 5.58006 19.24 5.58006Z"
                    fill="#292D32"
                  />
                  <path
                    d="M19.6509 10.7001H4.36094C4.07094 10.7001 3.75094 10.6901 3.46094 10.6101L4.72094 18.3001C5.00094 20.0201 5.75094 22.0001 9.08094 22.0001H14.6909C18.0609 22.0001 18.6609 20.3101 19.0209 18.4201L20.5309 10.6101C20.2509 10.6801 19.9509 10.7001 19.6509 10.7001ZM12.0009 18.5001C9.66094 18.5001 7.75094 16.5901 7.75094 14.2501C7.75094 13.8401 8.09094 13.5001 8.50094 13.5001C8.91094 13.5001 9.25094 13.8401 9.25094 14.2501C9.25094 15.7701 10.4809 17.0001 12.0009 17.0001C13.5209 17.0001 14.7509 15.7701 14.7509 14.2501C14.7509 13.8401 15.0909 13.5001 15.5009 13.5001C15.9109 13.5001 16.2509 13.8401 16.2509 14.2501C16.2509 16.5901 14.3409 18.5001 12.0009 18.5001Z"
                    fill="#292D32"
                  />
                </svg>
              </span>
            </Link>
          </div>
        </>
      )}

      {location.pathname == "/shopCart" && (
        <>
          {/* <h2 className="dark:text-white">کافه لئو</h2> */}
          <img className="w-16" src={leoLogo} alt="" />

          {/* <Link to="/" > */}
          <span
            onClick={goBack}
            className="h-10 w-10 shadow-md dark:bg-gray-800 shadow-gray-600 dark:shadow-slate-400 rounded flex justify-center items-center relative "
          >
            <svg
              className="dark:invert"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.4"
                d="M7.81 2H16.18C19.83 2 22 4.17 22 7.81V16.18C22 19.82 19.83 21.99 16.19 21.99H7.81C4.17 22 2 19.83 2 16.19V7.81C2 4.17 4.17 2 7.81 2Z"
                fill="#292D32"
              />
              <path
                d="M13.9195 8.98006H8.76945L9.09945 8.65006C9.38945 8.36006 9.38945 7.88006 9.09945 7.59006C8.80945 7.30006 8.32945 7.30006 8.03945 7.59006L6.46945 9.16006C6.17945 9.45006 6.17945 9.93006 6.46945 10.2201L8.03945 11.7901C8.18945 11.9401 8.37945 12.0101 8.56945 12.0101C8.75945 12.0101 8.94945 11.9401 9.09945 11.7901C9.38945 11.5001 9.38945 11.0201 9.09945 10.7301L8.83945 10.4701H13.9195C15.1995 10.4701 16.2495 11.5101 16.2495 12.8001C16.2495 14.0901 15.2095 15.1301 13.9195 15.1301H8.99945C8.58945 15.1301 8.24945 15.4701 8.24945 15.8801C8.24945 16.2901 8.58945 16.6301 8.99945 16.6301H13.9195C16.0295 16.6301 17.7495 14.9101 17.7495 12.8001C17.7495 10.6901 16.0295 8.98006 13.9195 8.98006Z"
                fill="#292D32"
              />
            </svg>
          </span>
          {/* </Link> */}
        </>
      )}
      {location.pathname == "/location" && (
        <>
          <span
            className="h-10 w-10 shadow-md dark:bg-gray-800 shadow-gray-600 dark:shadow-slate-400 rounded flex justify-center items-center relative "
            onClick={() => setShow(!show)}
          >
            {!show && (
              <svg
                className="dark:invert"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.2385 15.5943C15.4946 15.131 14.5639 15.0856 13.7785 15.4743L10.7785 12.4743C11.0007 11.9676 11.0499 11.4018 10.9185 10.8643C10.8962 10.7895 10.8694 10.716 10.8385 10.6443L13.7785 7.70433C14.8794 8.24712 16.2117 7.90299 16.912 6.89498C17.6122 5.88697 17.4698 4.51834 16.5771 3.67607C15.6843 2.83381 14.3096 2.77132 13.3441 3.52909C12.3786 4.28687 12.1126 5.63694 12.7185 6.70433L9.9485 9.43433C9.00536 8.76394 7.72541 8.82839 6.85437 9.59013C5.98333 10.3519 5.74886 11.6118 6.28756 12.6359C6.82626 13.66 7.99733 14.1806 9.1185 13.8943C9.35153 13.8259 9.57372 13.7249 9.7785 13.5943L12.7785 16.5943C12.1624 17.7989 12.6209 19.2751 13.811 19.9186C15.0012 20.5621 16.4875 20.1375 17.158 18.9623C17.8286 17.7871 17.438 16.2916 16.2785 15.5943H16.2385Z"
                  fill="black"
                />
              </svg>
            )}
            {show && (
              <svg
                className="dark:invert"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.7188 18.3906L13.325 12.0004L19.7188 5.65714C20.0392 5.28603 20.0219 4.72911 19.679 4.37894C19.3361 4.02878 18.7832 4.00341 18.4101 4.32073L11.9976 10.6169L5.69734 4.27367C5.33275 3.90878 4.74392 3.90878 4.37933 4.27367C4.20236 4.45039 4.10282 4.69094 4.10282 4.94188C4.10282 5.19282 4.20236 5.43337 4.37933 5.61008L10.6703 11.9439L4.2765 18.2777C4.09954 18.4544 4 18.695 4 18.9459C4 19.1969 4.09954 19.4374 4.2765 19.6141C4.45291 19.7903 4.69172 19.8885 4.94018 19.887C5.18409 19.8885 5.41891 19.794 5.59452 19.6235L11.9976 13.2709L18.4101 19.7271C18.5865 19.9032 18.8253 20.0014 19.0738 20C19.319 19.9989 19.554 19.9009 19.7281 19.7271C19.9039 19.5491 20.0017 19.3078 20 19.0569C19.9982 18.8059 19.897 18.5661 19.7188 18.3906Z"
                  fill="black"
                />
              </svg>
            )}
          </span>
          {/* <h2 className="dark:text-white">کافه لئو</h2> */}
          <img className="w-16" src={leoLogo} alt="" />

          <Link to="/">
            <span className="h-10 w-10 shadow-md dark:bg-gray-800 shadow-gray-600 dark:shadow-slate-400 rounded flex justify-center items-center relative ">
              <svg
                className="dark:invert"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M20.03 6.82018L14.28 2.79018C12.71 1.69018 10.31 1.75018 8.8 2.92018L3.79 6.83018C2.78 7.61018 2 9.21018 2 10.4702V17.3702C2 19.9202 4.07 22.0002 6.61 22.0002H17.38C19.92 22.0002 21.99 19.9302 21.99 17.3802V10.6002C22 9.25018 21.13 7.59018 20.03 6.82018Z"
                  fill="#292D32"
                />
                <path
                  d="M13.3994 8.51025H10.5994C8.67938 8.51025 7.10938 10.0703 7.10938 12.0003V14.7903C7.10938 16.7103 8.67938 18.2803 10.5994 18.2803H13.3894C15.3094 18.2803 16.8794 16.7203 16.8794 14.7903V12.0003C16.8794 10.0803 15.3194 8.51025 13.3994 8.51025ZM15.4894 12.0003V12.7003H12.6994V9.91025H13.3994C14.5494 9.91025 15.4894 10.8503 15.4894 12.0003ZM10.5994 9.91025H11.2994V12.7003H8.50938V12.0003C8.50938 10.8503 9.44938 9.91025 10.5994 9.91025ZM8.50938 14.7903V14.0903H11.2994V16.8803H10.5994C9.44938 16.8803 8.50938 15.9403 8.50938 14.7903ZM13.3994 16.8803H12.6994V14.0903H15.4894V14.7903C15.4894 15.9403 14.5494 16.8803 13.3994 16.8803Z"
                  fill="#292D32"
                />
              </svg>
            </span>
          </Link>
          {show && (
            <div className="share px-3 bg-gray-50 shadow-lg absolute w-11/12  pb-6 pt-4 dark:bg-gray-900 top-16 rounded-lg">
              <p className= " dark:text-white mb-4" >آدرس ما را با دوستانتان به اشتراک بگذارید</p>
              <div className="flex justify-between">
                <TelegramShareButton
                  
                  url={shareURL}
                  title={shareText}
                >
                  <TelegramIcon className="rounded-lg w-12 h-12" />
                </TelegramShareButton>
                <WhatsappShareButton
                  
                  url={shareURL}
                  title={shareText}
                >
                  <WhatsappIcon className="rounded-lg w-12 h-12" />
                </WhatsappShareButton>
                <EmailShareButton
                  
                  url={shareURL}
                  body={shareText}
                >
                  <EmailIcon className="rounded-lg w-12 h-12" />
                </EmailShareButton>
              </div>
              <div className="copy flex gap-2 justify-between items-center px-1 w-full overflow-x-hidden bg-gray-500 h-10 mt-4 rounded-lg  ">
                <div className="right bg-gray-200 rounded">
                  <span onClick={copy} className="cursor-pointer ">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 6C2 3.79086 3.79086 2 6 2H14C16.2091 2 18 3.79086 18 6V14C18 16.2091 16.2091 18 14 18H6C3.79086 18 2 16.2091 2 14V6Z"
                        fill="black"
                      />
                      <path
                        d="M17 21.75H9C8.58417 21.7445 8.24996 21.4059 8.25 20.99C8.25547 20.5797 8.58966 20.25 9 20.25H17C17.8637 20.25 18.6919 19.9062 19.3016 19.2946C19.9114 18.6829 20.2527 17.8537 20.25 16.99V8.99C20.25 8.57579 20.5858 8.24 21 8.24C21.4142 8.24 21.75 8.57579 21.75 8.99V16.99C21.75 19.615 19.625 21.7445 17 21.75Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </div>
                
                <div className="left overflow-x-hidden">
                  <p className="flex justify-center items-center rounded-md  bg-gray-100 px-1">{window.location.href}</p>
                </div>
              </div>
              {showCopy && 
                <p className="dark:text-gray-200 pt-4 text-center ">کپی شد</p>
                }
            </div>
          )}
        </>
      )}
    </header>
  );
};

export default Header;
